import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=19742faa&scoped=true&"
import script from "./EmptyLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=19742faa&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19742faa",
  null
  
)

export default component.exports